import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { HeaderContent } from "./HeaderContent";
import { cambiarelestadoEmpresa, getBitacoraEmpresa, getSpecificempresa, insertartBitacoraEmpresa } from "../../../../store/Empresa/thunkEmpresa";
import { Clientes } from "./Clientes";
import { CambiarLogoEmpresa } from "./CambiarLogoEmpresa";
import { apiUrlImg } from "../../../../api";
import { BitacoraEmpresa } from "./BitacoraEmpresa";
import Swal from "sweetalert2";
import { ModalEditarEmpresa } from "./ModalEditarEmpresa";
import { InformacionEmpresa } from "./InformacionEmpresa";

export const PerfilEmpresa = () => {
    const dispatch = useDispatch();
    const [empresaDetails, setEmpresaDetails] = useState({});
    const [activeTab, setActiveTab] = useState("clientes");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState("");

    const handleTabClick = (tabKey) => {
        setActiveTab(tabKey);
    };

    const fetchempresaDetails = async (idempresa) => {
        try {
            document.querySelector("#logoempresas").src = "/avatar.webp";
            const empresaData = await dispatch(getSpecificempresa(idempresa));
            setEmpresaDetails(empresaData);

            const response = await fetch(`${apiUrlImg}${empresaData.logoEmpresa}`);
            if (response.ok) {
                const imageBlob = await response.blob();
                document.querySelector("#logoempresas").src = URL.createObjectURL(imageBlob);
            } else {
                throw new Error("Failed to load image");
            }
        } catch (error) {
            console.error("Error:", error);
            document.querySelector("#logoempresas").alt = "Failed to load image";
        }
    };
    const [BitacoraLeads, setBitacora] = useState([]);

    const fetchBitacora = async (idempresa) => {
        try {
            const result = await dispatch(getBitacoraEmpresa(idempresa)); // Llama a la acción de Redux para obtener la bitácora del lead.
            setBitacora(result); // Almacena los resultados en el estado.
        } catch (error) {
            console.error("Error fetching bitacora:", error); // Maneja cualquier error.
        }
    };

    const getQueryParam = (param) => {
        const value = new URLSearchParams(location.search).get(param);
        if (value && !isNaN(value) && !isNaN(parseFloat(value))) {
            return Number(value);
        }
        return value;
    };

    const handleImageClick = () => {
        const imageSrc = document.querySelector("#logoempresas").src;
        setModalImageSrc(imageSrc);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        const empresaid = getQueryParam("data");
        if (empresaid && empresaid > 0) {
            fetchempresaDetails(empresaid);
            fetchBitacora(empresaid);
        }
    }, []);

    const agregarNotad = () => {
        Swal.fire({
            title: "Agregar nota",
            input: "textarea",
            inputLabel: "Escribe tu nota aquí",
            inputPlaceholder: "Escribe algo...",
            showCancelButton: true,
            confirmButtonText: "Enviar nota",
            cancelButtonText: "Cancelar",
            allowOutsideClick: false,
            allowEscapeKey: false,
            preConfirm: (note) => {
                if (!note) {
                    Swal.showValidationMessage("La nota no puede estar vacía");
                } else {
                    return note;
                }
            },
        }).then(async (swalResult) => {
            if (swalResult.isConfirmed) {
                const nota = swalResult.value;

                // Mostrar preloader
                Swal.fire({
                    title: `Creando nota de empresa`,
                    text: "Por favor espere...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                // Llama a la acción para cambiar el estado del cliente
                await dispatch(insertartBitacoraEmpresa(nota, empresaDetails.id_empresa));

                // Mensaje de éxito y cierre del modal
                Swal.fire({
                    icon: "success",
                    title: `Nota creada con exito`,
                    text: `Se agrego una nota nueva a la empresa ${empresaDetails.nombre_empresa}`,
                    confirmButtonText: "Aceptar",
                    timer: 2000, // Duración de 5 segundos
                    timerProgressBar: true, // Mostrar barra de progreso
                }).then(() => {
                    const empresaid = getQueryParam("data");
                    window.location.href = `/empresas/perfil?data=${empresaid}`;
                });
            }
        });
    };

    const [openModalEditarEmpresa, setopenModalEditarEmpresa] = useState(false);

    const openMohandleRowClickEditarEmpresadalEditarEmpresa = () => {
        setopenModalEditarEmpresa(true);
    };

    const handleCloseModalEditarEmpresa = () => {
        setopenModalEditarEmpresa(false);
    };

    const updateCompanyStatus = (status) => {
        // Define el texto dinámico según el valor de `status`
        const actionText = status === 1 ? "activar" : "inactivar";
        const successText = status === 1 ? "activada" : "inactivada";

        Swal.fire({
            title: `¿Estás seguro de que deseas ${actionText} la empresa?`,
            text: `¿Deseas ${actionText} la empresa con la información proporcionada?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: `Sí, ${actionText}`,
            cancelButtonText: "Cancelar",
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(async (result) => {
            if (result.isConfirmed) {
                // Mostrar preloader
                Swal.fire({
                    title: `${actionText.charAt(0).toUpperCase() + actionText.slice(1)} empresa`,
                    text: "Por favor espere...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                // Llama a la acción para cambiar el estado de la empresa
                await dispatch(cambiarelestadoEmpresa(empresaDetails, status));

                // Mensaje de éxito y cierre del modal
                Swal.fire({
                    icon: "success",
                    title: `Empresa ${successText}`,
                    text: `La empresa ha sido ${successText} exitosamente.`,
                    confirmButtonText: "Aceptar",
                    timer: 2000, // Duración de 2 segundos
                    timerProgressBar: true,
                }).then(() => {
                    const empresaid = getQueryParam("data");
                    fetchempresaDetails(empresaid);
                });
            }
        });
    };

    return (
        <>
            <HeaderContent empresaInformations={empresaDetails} />
            <div className="row">
                <div className="col-xxl-3 col-lg-5">
                    <div className="overflow-hidden card">
                        <div className="position-relative card-body">
                            <div className="text-center mt-3">
                                <div className="chat-avtar d-inline-flex mx-auto">
                                    <img id="logoempresas" alt="User image" className="img-fluid wid-180 img-thumbnail" style={{ color: "transparent" }} onClick={handleImageClick} />
                                    <i className="chat-badge bg-success me-2 mb-2"></i>
                                </div>
                                <h5 className="mb-0">{empresaDetails.nombre_empresa}</h5>
                                <ul className="list-inline mx-auto my-4">
                                    <li className="list-inline-item">
                                        <button className="btn btn-sm btn-dark" onClick={() => openMohandleRowClickEditarEmpresadalEditarEmpresa()}>
                                            <i className="ti ti-edit-circle f-24"></i> Editar Empresa
                                        </button>
                                    </li>
                                    <li className="list-inline-item">
                                        {empresaDetails.estado_empresa === 1 ? (
                                            <button className="btn btn-sm btn-danger" onClick={() => updateCompanyStatus(0)}>
                                                <i className="ti ti-x f-24"></i> Inactivar Empresa
                                            </button>
                                        ) : (
                                            <button className="btn btn-sm btn-success" onClick={() => updateCompanyStatus(1)}>
                                                <i className="ti ti-check f-24"></i> Activar Empresa
                                            </button>
                                        )}
                                    </li>
                                </ul>
                                <ul className="list-inline mx-auto my-4">
                                    <li className="list-inline-item">
                                        <button className="btn btn-sm btn-dark" onClick={() => agregarNotad(0)}>
                                            <i className="ti ti-edit-circle f-24"></i> Agregar Nota de Seguimiento
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="flex-column list-group list-group-flush account-pills mb-0 nav nav-pills" id="user-set-tab" aria-orientation="vertical" role="tablist">
                            <a onClick={() => handleTabClick("clientes")} role="tab" className={`list-group-item list-group-item-action nav-link ${activeTab === "clientes" ? "active" : ""}`}>
                                <span className="f-w-500">
                                    <i className="ph-duotone ph-calendar m-r-10"></i> Lista de clientes
                                </span>
                            </a>
                            <a onClick={() => handleTabClick("Informacion")} role="tab" className={`list-group-item list-group-item-action nav-link ${activeTab === "Informacion" ? "active" : ""}`}>
                                <span className="f-w-500">
                                    <i className="ph-duotone ph-user-circle m-r-10"></i> Informacion Completada
                                </span>
                            </a>
                            <a onClick={() => handleTabClick("Bitacora")} role="tab" className={`list-group-item list-group-item-action nav-link ${activeTab === "Bitacora" ? "active" : ""}`}>
                                <span className="f-w-500">
                                    <i className="ph-duotone ph-user-circle m-r-10"></i>Bitácora de Seguimiento
                                </span>
                            </a>
                            <a onClick={() => handleTabClick("logoempresa")} role="tab" className={`list-group-item list-group-item-action nav-link ${activeTab === "logoempresa" ? "active" : ""}`}>
                                <span className="f-w-500">
                                    <i className="ph-duotone ph-user-switch m-r-10"></i> Cambiar logo de la empresa
                                </span>
                            </a>
                            <a onClick={() => handleTabClick("Oportunidades")} role="tab" className={`list-group-item list-group-item-action nav-link ${activeTab === "Oportunidades" ? "active" : ""}`}>
                                <span className="f-w-500">
                                    <i className="ph-duotone ph-notebook m-r-10"></i> Cotizaciones
                                </span>
                            </a>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <h5>Informacion Basica</h5>
                        </div>
                        <div className="position-relative card-body">
                            <div className="d-inline-flex align-items-center justify-content-between w-100 mb-3">
                                <p className="mb-0 text-muted me-1">Nombre comercial</p>
                                <p className="mb-0">{empresaDetails.nombre_comercial || "No especificado"}</p>
                            </div>
                            <div className="d-inline-flex align-items-center justify-content-between w-100 mb-3">
                                <p className="mb-0 text-muted me-1">Cédula jurídica</p>
                                <p className="mb-0">{empresaDetails.cedula_juridica || "No especificado"}</p>
                            </div>
                            <div className="d-inline-flex align-items-center justify-content-between w-100 mb-3">
                                <p className="mb-0 text-muted me-1">Teléfono</p>
                                <p className="mb-0">{empresaDetails.telefono || "No especificado"}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-9 col-lg-7">
                    <div className="tab-content" id="user-set-tabContent">
                        {activeTab === "clientes" && (
                            <div id="react-aria8348725315-:r6:-tabpane-clientes" role="tabpanel" aria-labelledby="react-aria8348725315-:r6:-tab-clientes" className="fade fade tab-pane active show">
                                <Clientes clientes={empresaDetails} />
                            </div>
                        )}
                        {activeTab === "Bitacora" && (
                            <div id="react-aria8348725315-:r6:-tabpane-Bitacora" role="tabpanel" aria-labelledby="react-aria8348725315-:r6:-tab-Bitacora" className="fade fade tab-pane active show">
                                <BitacoraEmpresa BitacoraLeads={BitacoraLeads} />
                            </div>
                        )}
                        {activeTab === "logoempresa" && (
                            <div id="react-aria8348725315-:r6:-tabpane-logoempresa" role="tabpanel" aria-labelledby="react-aria8348725315-:r6:-tab-clientes" className="fade fade tab-pane active show">
                                <CambiarLogoEmpresa empresa={empresaDetails} />
                            </div>
                        )}
                        {activeTab === "Informacion" && (
                            <div id="react-aria8348725315-:r6:-tabpane-Informacion" role="tabpanel" aria-labelledby="react-aria8348725315-:r6:-tab-clientes" className="fade fade tab-pane active show">
                                <InformacionEmpresa empresaDetail={empresaDetails} />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }} onClick={closeModal}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Logo de la emprsa</h5>
                                <button type="button" className="btn-close" onClick={closeModal}></button>
                            </div>
                            <div className="modal-body">
                                <img src={modalImageSrc} alt="Preview" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {openModalEditarEmpresa && <ModalEditarEmpresa open={true} onClose={handleCloseModalEditarEmpresa} empresaDetails={empresaDetails} />}
        </>
    );
};
